import get from 'lodash/get';
import DefaultDialogController from 'utils/notifications/default-dialog-controller';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import alertModalTpl from './alert-modal-tpl.html';

const NOT_AUTHORIZED_CODE = 'NOT_AUTHORIZED';

const mapStateToThis = ({ dirtyForms, dictionary, session, contact }) => {
  const { locale } = session;
  const {
    lottery: { defaultContactPhone },
  } = contact;
  const terms = dictionary.terms[locale];

  return {
    dirtyForms,
    terms,
    defaultContactPhone,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'Notifications', 'gettextCatalog')
class ErrorNotificationService {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.dialogOpened = false;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  initialize(config) {
    this.config = config;
  }

  gotoHome() {
    Object.keys(this.dirtyForms).forEach((key) => this.setDirtyForm(key, false));

    return this.$state.go('home-view', null, {
      reload: true,
      skipDirtyForms: true,
    });
  }

  notifyUnknownServerError() {
    const message = {
      title: this.gettextCatalog.getString('Error occurred!'),
      body: this.gettextCatalog.getString('Please try again later or please call {{ contactPhone }} for assistance', {
        contactPhone: this.defaultContactPhone,
      }),
    };
    return this.showMessage(message);
  }

  notifyStatus408() {
    const message = {
      title: this.gettextCatalog.getString('Error occurred!'),
      body: this.gettextCatalog.getString('System processing in progress. Please try again later.'),
    };
    return this.showMessage(message);
  }

  notifyStatus409() {
    const message = {
      title: this.gettextCatalog.getString('Notification'),
      body: this.gettextCatalog.getString('The form has already been sent during another session.'),
    };
    return this.showMessage(message).then(() => this.$state.go('dashboard-summary'));
  }

  notifyServerError(err, context) {
    const unexpectedServerError = this.config.errorCodes.UNEXPECTED_SERVER_ERROR;
    const defaultErrorCode = this.config.errorCodes.default;

    const errorCode = get(err, 'data.errors[0].code', unexpectedServerError);
    const params = get(err, 'data.errors[0].params', {});
    const message = get(err, 'data.errors[0].message', {});
    const contextError = get(this.config.errorCodes, `${context}['${errorCode}']`, defaultErrorCode);
    const payload = get(err, 'config.data', {});

    const parameters = {
      message,
      terms: this.terms,
      contactPhone: this.defaultContactPhone,
      payload,
      ...params,
    };

    return this.showMessage(contextError(parameters));
  }

  notifyUnauthorized() {
    const message = {
      title: this.gettextCatalog.getString('Error occurred!'),
      body: this.config.errorCodes.app[NOT_AUTHORIZED_CODE]().body,
    };
    return this.showMessage(message);
  }

  notifyForcedLogout() {
    const message = {
      title: this.gettextCatalog.getString('User Session Expired!'),
      body: this.gettextCatalog.getString('You will now be redirected to the login screen'),
    };

    return Promise.resolve(
      this.showMessage(message)
        .then(() => this.gotoHome())
        .catch(() => this.gotoHome())
    );
  }

  showMessage({
    controller = DefaultDialogController,
    template = alertModalTpl,
    backdrop = true,
    size = 'md',
    component = null,
    dontShow,
    resolve,
    title,
    body,
  }) {
    if (dontShow === true) return Promise.resolve();

    resolve = {
      message: () => body,
      title: () => title,
      ...resolve,
    };

    if (!this.dialogOpened) {
      this.dialogOpened = true;

      let config = {
        template,
        controller,
        backdrop,
        resolve,
        size,
      };

      if (component) {
        config = {
          template,
          component,
          backdrop,
          resolve,
          size,
        };
      }

      return this.Notifications.showComplexDialog({
        ...config,
      })
        .result.then((data) => {
          this.dialogOpened = false;
          return Promise.resolve(data);
        })
        .catch((err) => {
          this.dialogOpened = false;
          return Promise.reject(err);
        });
    }
    return Promise.resolve();
  }
}

export default ErrorNotificationService;



// WEBPACK FOOTER //
// ./src/modules/utils/rest/error/error-notification-service.js